module.exports = __webpack_public_path__ + "static/media/08.9c115734.jpg";